<template>
  <footer id="footer_section">
    <div class="container">
      <div class="row">
        <div class="col-5 col-sm-5 col-md-5 col-lg-5">
          <div class="copy_right">© IFAN FLEX Pvt. Ltd.</div>
        </div>
        <div class="col-7 col-sm-7 col-md-7 col-lg-7">
          <div class="term_condition">
            <router-link class="mr-2" to="/terms-and-condition">T &amp; C</router-link>
            <span>|</span>
            <router-link class="ml-2" to="/privacy-policy">Privacy Policy</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
  background-color: #ccc;
  padding: 40px 0;
  width: 100%;
  margin-top: auto;
}
#footer_section {
  padding: 10px 0;
  background-image: linear-gradient(104deg, #f44c34, #044484 102%);
  display: block;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9;
  .copy_right {
    font-size: 12px;
    font-weight: 300;
    color: #fff;
  }
  .term_condition {
    text-align: right;
    color: #fff;
    a {
      font-size: 16px;
      font-weight: 300;
      color: #fff;
    }
  }
}
</style>
